import isEmail from 'validator/lib/isEmail';
import type { DeclaredStudentRow } from './declared-students';
import { validateDeclaredStudents } from './declared-students';
import { guardianDistrictValidation } from './teacher-district';
export const teacherRegisterErrorMessages = {
	titleError: 'Prosimy o wybór tytułu.',
	degreeError: 'Prosimy o uzupełnienie stopnia naukowego.',
	affiliationError: 'Prosimy o uzupełnienie afiliacji.',
	categoryError: 'Prosimy o wybór kategorii.',
	studentsError: 'Prosimy o wpisanie podopiecznych.',
	nameError: 'Prosimy o uzupełnienie imienia.',
	secondNameError: 'Prosimy o uzupełnienie drugiego imienia.',
	surnameError: 'Prosimy o uzupełnienie nazwiska.',
	emailError: 'Prosimy o podanie poprawnego adresu e-mail.',
	phoneError: '',
	districtError: 'Prosimy o wybór okręgu.',
	streetError: 'Prosimy o uzupełnienie ulicy.',
	buildingError: 'Prosimy o uzupełnienie numeru budynku.',
	apartmentError: '',
	zipCodeError: 'Prosimy o podanie poprawnego kodu pocztowego.',
	cityError: 'Prosimy o uzupełnienie miasta.',
	rodoError: 'Prosimy o zaznaczenie wymaganych zgód.',
	consentError: 'Prosimy o zaznaczenie wymaganych zgód.',
	passwordError: 'Hasło musi mieć co najmniej 8 znaków.',
	passwordConfirmError: 'Hasła muszą być identyczne.',
};

export type TeacherRegisterValidation = {
	[K in keyof typeof teacherRegisterErrorMessages]: string;
};

export function emptyTeacherRegisterValidation(): TeacherRegisterValidation {
	return {
		titleError: '',
		degreeError: '',
		affiliationError: '',
		categoryError: '',
		studentsError: '',
		nameError: '',
		secondNameError: '',
		surnameError: '',
		emailError: '',
		phoneError: '',
		districtError: '',
		streetError: '',
		buildingError: '',
		apartmentError: '',
		zipCodeError: '',
		cityError: '',
		rodoError: '',
		consentError: '',
		passwordError: '',
		passwordConfirmError: '',
	};
}

type TeacherFormSlice = {
	personalTitle: string;
	academicDegree: string;
	firstName: string;
	secondName: string;
	lastName: string;
	category: string;
	affiliation: string;
	schoolRspo: string;
	email: string;
	phone: string;
	city: string;
	street: string;
	zipCode: string;
	building: string;
	apartment: string;
	districtId: string;
	noSchoolFacility: boolean;
};

type HelperSlice = {
	district: string;
	rodo: string | boolean;
	consent: string | boolean;
};

/** Bezpieczne odczytanie pól tekstowych (districtId bywa number z dropdown). */
function strField(value: unknown): string {
	if (value === null || value === undefined) {
		return '';
	}
	return String(value).trim();
}

/** Walidacja spójna z handlerami pól — używana po prefill i przy submit. */
export function computeTeacherRegisterValidation(args: {
	formInfo: TeacherFormSlice;
	helperInputInfo: HelperSlice;
	isSecondName: boolean | string;
	schoolFromCatalog: boolean;
	declaredStudents: DeclaredStudentRow[];
	districtNames: string[];
}): TeacherRegisterValidation {
	const { formInfo, helperInputInfo, isSecondName, schoolFromCatalog, declaredStudents, districtNames } = args;
	const m = teacherRegisterErrorMessages;

	const districtIdStr = strField(formInfo.districtId);
	const districtNameStr = strField(helperInputInfo.district);

	let districtError = '';
	if (!districtIdStr || !districtNameStr) {
		districtError = m.districtError;
	} else if (formInfo.noSchoolFacility) {
		districtError = guardianDistrictValidation(districtNameStr, formInfo.city, formInfo.zipCode, districtNames) || '';
	}

	const studentsErr = validateDeclaredStudents(declaredStudents);

	return {
		titleError: !formInfo.personalTitle.trim() ? m.titleError : '',
		degreeError: !formInfo.academicDegree.trim() ? m.degreeError : '',
		nameError: !formInfo.firstName.trim() ? m.nameError : '',
		secondNameError: isSecondName && !formInfo.secondName.trim() ? m.secondNameError : '',
		surnameError: !formInfo.lastName.trim() ? m.surnameError : '',
		categoryError: !formInfo.category.trim() ? m.categoryError : '',
		affiliationError:
			!formInfo.noSchoolFacility && (!schoolFromCatalog || !formInfo.schoolRspo.trim()) ? m.affiliationError : '',
		streetError: formInfo.noSchoolFacility && !formInfo.street.trim() ? m.streetError : '',
		buildingError: formInfo.noSchoolFacility && !formInfo.building.trim() ? m.buildingError : '',
		apartmentError: '',
		zipCodeError: formInfo.noSchoolFacility && formInfo.zipCode.replace(/\D/g, '').length !== 5 ? m.zipCodeError : '',
		cityError: formInfo.noSchoolFacility && !formInfo.city.trim() ? m.cityError : '',
		emailError: !formInfo.email.trim() ? m.emailError : !isEmail(formInfo.email) ? 'Niepoprawny adres e-mail' : '',
		phoneError: '',
		districtError,
		studentsError: studentsErr || '',
		rodoError: !helperInputInfo.rodo ? m.rodoError : '',
		consentError: !helperInputInfo.consent ? m.consentError : '',
		passwordError: '',
		passwordConfirmError: '',
	};
}
